import { Contexts } from "@/types";
export const contexts = [
  {
    value: Contexts.None,
    name: "-- None --",
  },
  {
    value: Contexts.UniqueId,
    name: "UniqueId",
  },
  {
    value: Contexts.SumInsured,
    name: "SumInsured",
  },
  {
    value: Contexts.AddressId,
    name: "AddressId",
  },
  {
    value: Contexts.AddressLine,
    name: "AddressLine (multiple address column)",
  },
  {
    value: Contexts.Address,
    name: "Address (only one address column)",
  },
  {
    value: Contexts.Postcode,
    name: "Postcode",
  },
  {
    value: Contexts.Latitude,
    name: "Latitude",
  },
  {
    value: Contexts.Longitude,
    name: "Longitude",
  },
];
